import React, { useEffect, useState } from "react";
import "../Style/Admin.css";
import { getOrganizationDetails } from "../Services/AdminService";
import { IOrganizationDetails } from "../Interfaces/IorgProfile";
import "../Style/OrgDetailPopup.css";
import "../Style/Common.css";
import SubscriptionUsageBanner from "../Subscriptions/Subscriptionusagebanner";

const OrgDetailsPopup = ({ onClose }: { onClose: () => void }) => {
  const [orgDetails, setOrgDetails] = useState<Partial<IOrganizationDetails>>({
    email: "",
    phone: 0,
    OwnerName: "",
    OrgName: "",
    orgId: "",
    status: "",
    userType: "",
    validUpThroughDate: undefined,
    validFromDate: undefined,
    sysIP: "",
    creationDate: undefined,
    orgLocation: "",
    industory: "",
    timeZone: "",
    currency: "",
    accountDetails: [],
    address: [
      {
        addressLine2: "",
        zipCode: 0,
        addressLine1: "",
        city: "",
        state: "",
      },
    ],
    GST: 0,
    createdBy: "",
    createdSysIp: 0,
    logo: "",
    termAndCondition: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      try {
        // Replace this with your actual API call
        const orgId = localStorage.getItem('orgId') ?? ''; 
        const response = await getOrganizationDetails(orgId); // Pass org Id
        const data = response;
        const orgAddress=data?.address[0]?.addressLine1 +","+ data?.address[0]?.city + "\n"+data?.address[0]?.state +"-"+data?.address[0]?.zipCode
        localStorage.setItem("orgDetails",orgAddress);
        console.log(data?.address[0].addressLine1);
        if (data) {
          setOrgDetails(data);
          console.log(orgDetails);
        } else {
          throw new Error(
            data.message || "Failed to fetch organization details"
          );
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrgDetails();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" style={{ position: "fixed", top: 0, right: 0 }} onClick={onClose}>
          &times;
        </button>

        <h2 className="modal-title">Organization Details</h2>
        {/* Subscription plan / invoice usage — moved here from the Invoice page */}
        <SubscriptionUsageBanner />
        {/* Organization Details Card */}
        <div className="card org-details-card">
          <h3 className="card-title">Basic Information</h3>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Org Name:</strong>
            </div>
            <div className="info-data">{orgDetails.OrgName || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Owner Name:</strong>
            </div>
            <div className="info-data">{orgDetails.OwnerName || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Email:</strong>
            </div>
            <div className="info-data">{orgDetails.email || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Phone:</strong>
            </div>
            <div className="info-data">{orgDetails.phone || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Industry:</strong>
            </div>
            <div className="info-data">{orgDetails.industory || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Org Location:</strong>
            </div>
            <div className="info-data">{orgDetails.orgLocation || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Currency:</strong>
            </div>
            <div className="info-data">{orgDetails.currency || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Time Zone:</strong>
            </div>
            <div className="info-data">{orgDetails.timeZone || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Status:</strong>
            </div>
            <div className="info-data">{orgDetails.status || "N/A"}</div>
          </div>
        </div>

        {/* Address Card */}
        <div className="card org-address-card">
          <h3 className="card-title">Address</h3>
          {orgDetails.address && orgDetails.address.length > 0 ? (
            orgDetails.address.map((addr: any, index: number) => (
              <div key={index} className="address-item">
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>Address Line 1:</strong>
                  </div>
                  <div className="info-data">{addr.addressLine1 || "N/A"}</div>
                </div>
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>Address Line 2:</strong>
                  </div>
                  <div className="info-data">{addr.addressLine2 || "N/A"}</div>
                </div>
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>City:</strong>
                  </div>
                  <div className="info-data">{addr.city || "N/A"}</div>
                </div>
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>State:</strong>
                  </div>
                  <div className="info-data">{addr.state || "N/A"}</div>
                </div>
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>ZIP Code:</strong>
                  </div>
                  <div className="info-data">{addr.zipCode || "N/A"}</div>
                </div>
              </div>
            ))
          ) : (
            <p className="org-info-item">No Address Available</p>
          )}
        </div>

        {/* Bank Details Card */}
        <div className="card org-account-card">
          <h3 className="card-title">Bank Details</h3>
          {orgDetails.accountDetails && orgDetails.accountDetails.length > 0 ? (
            orgDetails.accountDetails.map((account: any, index: number) => (
              <div key={index} className="account-item">
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>Account Holder Name:</strong>
                  </div>
                  <div className="info-data">
                    {account.accountHolderName || "N/A"}
                  </div>
                </div>
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>Account Number:</strong>
                  </div>
                  <div className="info-data">
                    {account.accountNumber || "N/A"}
                  </div>
                </div>
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>Bank Name:</strong>
                  </div>
                  <div className="info-data">{account.bankName || "N/A"}</div>
                </div>
                <div className="org-info-item-row">
                  <div className="info-label">
                    <strong>IFSC Code:</strong>
                  </div>
                  <div className="info-data">{account.ifscCode || "N/A"}</div>
                </div>
              </div>
            ))
          ) : (
            <p className="org-info-item">No Bank Details Available</p>
          )}
        </div>

        {/* Other Details Card */}
        <div className="card org-other-details-card">
          <h3 className="card-title">Other Details</h3>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>GST:</strong>
            </div>
            <div className="info-data">{orgDetails.GST || "N/A"}</div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Creation Date:</strong>
            </div>
            <div className="info-data">
              {new Date(
                orgDetails.creationDate?._seconds
                  ? orgDetails.creationDate._seconds * 1000
                  : 0
              ).toLocaleDateString() || "N/A"}
            </div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Valid From:</strong>
            </div>
            <div className="info-data">
              {new Date(
                orgDetails.validFromDate?._seconds
                  ? orgDetails.validFromDate._seconds * 1000
                  : 0
              ).toLocaleDateString() || "N/A"}
            </div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Valid Through:</strong>
            </div>
            <div className="info-data">
              {new Date(
                orgDetails.validUpThroughDate?._seconds
                  ? orgDetails.validUpThroughDate._seconds * 1000
                  : 0
              ).toLocaleDateString() || "N/A"}
            </div>
          </div>
          <div className="org-info-item-row">
            <div className="info-label">
              <strong>Terms and Conditions:</strong>
            </div>
            <div className="info-data">
              {orgDetails?.termAndCondition || "N/A"}
            </div>
          </div>
        </div>

        {/* Organization Logo */}
        <div className="org-logo">
          <h3 className="section-title">Logo</h3>
          {orgDetails.logo ? (
            <img
              src={orgDetails.logo}
              alt="Organization Logo"
              className="logo-image"
            />
          ) : (
            <p className="org-info-item">No Logo Available</p>
          )}
        </div>
      </div>
    </div>
  );
};
export default OrgDetailsPopup;
